import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getDepartment } from '../../services/departmentService';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import DepartmentEmployeesTab from './tab-pages/DepartmentEmployeesTab';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 8px;
`;

export default function DepartmentDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [department, setDepartment] = useState(null);
  const [activeTab, setActiveTab] = useState('employees');

  useEffect(() => {
    getDepartment(id)
      .then((res) => setDepartment(res.data?.data))
      .catch(() => {});
  }, [id]);

  const tabs = [
    { key: 'employees', label: t('department.employees') },
  ];

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('department.title'), path: '/departments' },
          { label: department?.name || '...' },
        ]} />

        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      </StickyHeader>

      <TabContent>
        {activeTab === 'employees' && <DepartmentEmployeesTab departmentId={id} />}
      </TabContent>
    </PageContainer>
  );
}
